import { combineReducers } from 'redux';
import { StackDataReducer as StackDataRedux } from '../components/container/reducer';


export default combineReducers({
    StackDataRedux
});